import { lazy } from 'react';
import { authModules } from 'app/auth';
import i18next from 'i18next';
import enGB from './i18n/enGB';
import deAT from './i18n/deAT';

i18next.addResourceBundle('enGB', 'changelog', enGB);
i18next.addResourceBundle('deAT', 'changelog', deAT);

const Changelog = lazy(() => import('./Changelog'));

const ChangelogConfig = {
  settings: {
    layout: {
      config: {}
    }
  },
  auth: authModules.loggedin,
  routes: [
    {
      path: '/changelog',
      element: <Changelog />
    }
  ]
};

export default ChangelogConfig;

